import React, { useEffect, useState } from "react";
import { allHotels } from "../../../api/admin/hotel";

const MultiHotelSection = ({ setFormData, sectionIndex }) => {
  const [Data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [Show, setShow] = useState(false);
  const [Search, setSearch] = useState("");
  const [selectedHotel, setSelectedHotel] = useState("");
  useEffect(() => {
    allHotels(setData);
  }, []);
  const handleShow = () => {
    setShow(!Show);
  };
  useEffect(() => {
    if (Search.trim() === "") {
      setFilteredData(Data);
    } else {
      const result = Data.filter((item) =>
        item.hotelName.toLowerCase().includes(Search.toLowerCase())
      );
      setFilteredData(result);
    }
  }, [Search, Data]);
  const handleSelect = (item) => {
    const { hotelId, hotelName } = item;

    setFormData((prevData) => {
      const newData = [...prevData];
      const exists = newData[sectionIndex].selectedHotels.some(
        (h) => h.hotelId === hotelId
      );
      if (!exists) {
        newData[sectionIndex].selectedHotels.push({ hotelId, hotelName });
      }
      return newData;
    });

    setSelectedHotel(item);
    setShow(false);
  };

  return (
    <div className="w-full relative">
      <div
        onClick={handleShow}
        className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm cursor-pointer select-none flex justify-start items-center gap-3"
      >
        {selectedHotel ? (
          <>
            <div className="w-10 h-5 overflow-hidden rounded-sm">
              <img
                className="w-full h-full object-contain"
                src={selectedHotel.hotelLogo}
                alt=""
              />
            </div>
            <div className="flex gap-x-2 justify-start items-center">
              <p className="text-sm font-medium uppercase">
                {selectedHotel.hotelName}
              </p>
            </div>
          </>
        ) : (
          <div>
            <p>Select Hotel</p>
          </div>
        )}
      </div>
      {Show && (
        <div className="bg-white w-full max-h-[300px] overflow-y-auto p-3 absolute top-10 drop-shadow-lg left-1/2 -translate-x-1/2 rounded-lg z-10 border scrollbar-hide">
          <div className="space-y-3">
            <div>
              <input
                type="text"
                className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                placeholder="Search company by name"
                onChange={(e) => setSearch(e.target.value)}
                value={Search}
              />
            </div>
            <div>
              {filteredData.map((item, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => handleSelect(item)}
                    className="flex gap-2 justify-start items-center bg-white hover:bg-[#d7eaff] p-2 rounded-lg cursor-pointer"
                  >
                    <div className="w-10 h-5 overflow-hidden rounded-sm">
                      <img
                        className="w-full h-full object-contain"
                        src={item.hotelLogo}
                        alt=""
                      />
                    </div>
                    <div className="flex gap-x-2 justify-start items-center">
                      <p className="text-sm font-medium uppercase">
                        {item.hotelName}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiHotelSection;
